<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-card-title class="teal accent-4 white--text" primary-title>
                        <span class="title">Oops!</span>
                    </v-card-title>
                    <v-card-text>
                        You should not be here. Please do not open that door, just go back
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="teal accent-4 white--text" to="/">
                            <v-icon small>
                                arrow_back
                            </v-icon>
                            Go Back
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {}
</script>

<style scoped>

</style>
